export enum AutopilotSpeedTypeEnum {
    None,
    Air,
    True,
    Ground,
    Vertical
}

export enum AutopilotSpeedUnitsEnum {
    None,
    mps,
    kmh,
    kt,
    ms
}

export enum AutopilotSpeedUnitsStringEnum {
    None = "None",
    mps = "mps",
    kmh = "kmh",
    kt = "kt"
}